import { fnToLoadPageSpy } from '~/utils/pageSpy';

export default defineNuxtPlugin(() => {
    // 只在客户端 + 开发模式时执行
    if (import.meta.client && import.meta.env.DEV_MODE) {
        fnToLoadPageSpy();
    }
});
